import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
const __default__ = {
  methods: {
    init() {
      return;
    },

    handleClassroomChange() {
      return;
    },

    handleGroupChange() {
      return;
    }

  }
};
import moment from "moment";
import { getData } from "@/services/axios";
import CalendarHeading from "./CalendarHeading.vue";
import GroupClassSelectForm from "./GroupClassSelectForm.vue";
import MonthlyClassTable from "@/components/dekitus/monthly/MonthlyClassTable.vue";
import AttendanceTemperatureSwitch from "@/components/attendances/monthly/AttendanceTemperatureSwitch.vue";
import DekitusIntroduction from "@/components/common/DekitusIntroduction";

import { storeToRefs } from 'pinia';
import { useLoadingStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/loading.js';
import { useGradeClassroomStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/gradeClassroom.js';
import { useSchoolPlanStore } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/stores/schoolPlan.js';
import { useMonthlySummary } from '/codebuild/output/src1688139503/src/cocoo_school_admin/src/composables/monthlySummary.js';
import { watch, ref } from 'vue';
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'MonthlyDekitus',

  setup(__props) {
    // @ts-check
    const {
      isLoading
    } = storeToRefs(useLoadingStore());
    const {
      classrooms
    } = storeToRefs(useGradeClassroomStore());
    const {
      schoolPlan
    } = storeToRefs(useSchoolPlanStore());
    const {
      filter,
      monthData
    } = useMonthlySummary();
    watch(filter, () => {
      setData();
    }, {
      deep: true
    });
    const displayLabel = ref("book");
    /** @type Ref<Object<number, MonthData[]>> */

    const classMonthData = ref({});
    const dailyEvents = ref({});
    /** @type typeof classrooms */

    const visibleClassroom = ref([]);
    /** @type Ref<Object<number, any>> */

    const selectClassStudentAttendaceObject = ref({});
    const dekitusIds = ref([]);

    const setData = async () => {
      isLoading.value = true;
      const date = moment(filter.value.yearMonth);
      const data = await getData([`reader/get_students_with_attendance?dekitus=1&year_month=${date.format("YYYY-MM")}&classroom_id=${filter.value.classroomId}&group_id=${filter.value.groupId}`, "events?orderby=updated_at&order=asc&classroom_id=" + filter.value.classroomId + "&year_month=" + filter.value.yearMonth, "dekitus_id_stocks"]).catch(error => {
        console.log(error);
      }); // 表示するクラスを整理する

      selectClassStudentAttendaceObject.value = data[0].items;
      visibleClassroom.value = [];
      classMonthData.value = {};
      dailyEvents.value = {};

      if (filter.value.classroomId === 0) {
        // 全てのクラスを選択したとき
        classrooms.value.forEach(v => {
          if (selectClassStudentAttendaceObject.value[v.id]) {
            visibleClassroom.value.push(v);
            classMonthData.value[v.id] = structuredClone(monthData.value);
            dailyEvents.value[v.id] = {};
          }
        });
      } else {
        // 個別のクラスを選択したとき
        const classroom = classrooms.value.find(v => v.id === filter.value.classroomId);
        visibleClassroom.value.push(classroom);
        classMonthData.value[classroom.id] = structuredClone(monthData.value);
        dailyEvents.value[classroom.id] = {};
      }

      data[1].items.forEach(v => {
        // 月をまたぐ際は今月の範囲内に限定する
        const from = date.isSame(v.from, "month") ? moment(v.from) : date.clone().startOf("month");
        const to = date.isSame(v.to, "month") ? moment(v.to) : date.clone().endOf("month");

        while (from.isSameOrBefore(to, "day")) {
          v.classroom.forEach(w => {
            if (dailyEvents.value[w.classroom_id]) {
              const key = from.format("YYYY-MM-DD");

              if (dailyEvents.value[w.classroom_id][key]) {
                dailyEvents.value[w.classroom_id][key].push(v);
              } else {
                dailyEvents.value[w.classroom_id][key] = [v];
              }

              classMonthData.value[w.classroom_id][from.date() - 1].isSchoolDayOff = Boolean(v.is_school_day_off);
            }
          });
          from.add(1, "day");
        }
      });
      dekitusIds.value = data[2].items[0] && data[2].items[0].dekitus_ids ? data[2].items[0].dekitus_ids : [];
      isLoading.value = false;
    }; // created


    setData();
    return {
      __sfc: true,
      isLoading,
      classrooms,
      schoolPlan,
      filter,
      monthData,
      displayLabel,
      classMonthData,
      dailyEvents,
      visibleClassroom,
      selectClassStudentAttendaceObject,
      dekitusIds,
      setData,
      CalendarHeading,
      GroupClassSelectForm,
      MonthlyClassTable,
      AttendanceTemperatureSwitch,
      DekitusIntroduction
    };
  }

});